<template>
  <div>
    <div class="head">
      <div class="header">
        <div class="left">
          <div class="title_log">
            <img alt="" src="../../static/mobileHeadLogo.png" />
          </div>
        </div>
        <div class="right">
          <div class="language" @click="changeLang()">
            <div v-if="toggle" class="chese">ZH</div>
            <div v-else class="english">EN</div>
          </div>
          <div class="menu" @click="changeMenu">
            <img class="icon" src="../../static/icon.png" alt="" v-if="menu_disabled == false" />
            <img class="close" src="../../static/error.png" alt="" v-else />
          </div>
        </div>
      </div>
      <div class="navMenus" v-if="menu_disabled">
        <div class="menus">
          <ul>
            <li @click="goRouter('index')">
              <router-link to="index" :style="{ color: active['index'] === true ? '#FDD000' : '#fff' }">
                {{ $t('navbar.home') }}
              </router-link>
            </li>
            <li @click="goRouter('exhibition')">
              <router-link to="exhibition" :style="{ color: active['exhibition'] === true ? '#FDD000' : '#fff' }">
                {{ $t('navbar.exhibitionLists') }}
              </router-link>
            </li>
            <li @click="goRouter('exhibitsList')">
              <router-link to="exhibitsList" :style="{ color: active['exhibitsList'] === true ? '#FDD000' : '#fff' }">
                {{ $t('navbar.exhibitsLists') }}
              </router-link>
            </li>
            <li @click="goRouter('live')">
              <router-link to="live" :style="{ color: active['live'] === true ? '#FDD000' : '#fff' }">
                {{ $t('navbar.live') }}
              </router-link>
            </li>
            <li @click="goRouter('active')">
              <router-link to="active" :style="{ color: active['active'] === true ? '#FDD000' : '#fff' }">
                {{ $t('navbar.activity') }}
              </router-link>
            </li>
            <li class="online">
              <div class="screenTitle" @click="toggleLink">
                <div class="left">
                  {{ $t('navbar.onlineHall') }}
                </div>
                <!-- 右侧小箭头 -->
                <div class="right">
                  <i class="el-icon-arrow-up" v-if="!toggleable"></i>
                  <i class="el-icon-arrow-down" v-else></i>
                </div>
              </div>
            </li>
            <li class="toggleLink" v-if="toggleable" @click="routerLink('vr')">
              <router-link to="#">
                {{ $t('navbar.VRview') }}
              </router-link>
            </li>
            <li class="toggleLink" v-if="toggleable" @click="routerLink('imgView')">
              <router-link to="#">
                {{ $t('navbar.imgView') }}
              </router-link>
            </li>
            <li class="toggleLink" v-if="toggleable" @click="routerLink('videoView')">
              <router-link to="#">
                {{ $t('navbar.videoView') }}
              </router-link>
            </li>
            <li @click="jumpZh()">
              <router-link to="#">
                {{ $t('navbar.onlineWeb') }}
              </router-link>
            </li>
          </ul>
          <div class="login">
            <div class="leftBtn " :class="hasViewToken ? 'btn1' : 'btn'" @click="logins(1)">
              {{ hasViewToken ? $t('navbar.audienceCenter') : $t('navbar.audienceLogin') }}
            </div>
            <div class="rightBtn " :class="hasToken ? 'btn1' : 'btn'" @click="logins(2)">
              {{ hasToken ? $t('navbar.exhibitionCenter') : $t('navbar.exhibitionLogin') }}
            </div>
          </div>
        </div>
        <div style="width:100%;height:9.07vw"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as tools from '../../../utils/roulink';
import config from '../../../config';
import { testDomain } from '../../../utils/common'
export default {
  name: '',
  data() {
    return {
      toggle: false,
      menu_disabled: false,
      lang: 'zh',
      toggleable: false,
      active: {},
      hasToken: false,
      hasViewToken: false,
      hzweb: `${config.hzzhanhui}/m`,
      testBaseDomain: testDomain()
    };
  },
  created() {
    this.isActive();
    const href = window.location.href;
    this.switchRouter();

    const language = localStorage.getItem('lang');
    this.$i18n.locale = language == 'en' ? language : 'zh';
    this.lang = language == 'en' ? language : 'zh';
    this.toggle = language == 'en' ? true : false;

    const zsToken = localStorage.getItem('token');
    if (zsToken) {
      this.hasToken = true;
    }
    const viewToken = localStorage.getItem('viewToken');
    if (viewToken) {
      this.hasViewToken = true;
    }
    if (href.includes('viewFlag')) {
      localStorage.removeItem('viewToken');
      if (localStorage.getItem('lang')) {
        localStorage.removeItem('lang');
        this.$i18n.locale = 'zh';
        this.lang = 'zh';
      }
      this.hasViewToken = false;
    }
    if (href.includes('zsFlag')) {
      localStorage.removeItem('token');
      if (localStorage.getItem('lang')) {
        localStorage.removeItem('lang');
        this.$i18n.locale = 'zh';
        this.lang = 'zh';
      }
      this.hasToken = false;
    }
  },
  methods: {
    goRouter(name) {
      this.menu_disabled = !this.menu_disabled;
      this.$router.push({
        name: name,
      });
      if (this.menu_disabled == true) {
        // 去掉样式
        this.changeBodyStyle('false');
      } else {
        this.changeBodyStyle('true');
      }
    },
    //跳转展会官网
    jumpZh() {
      window.open(this.hzweb);
    },
    routerLink(flag) {
      let routerUrl;
      if (flag == 'vr') {
        routerUrl = this.testBaseDomain + 'index?slanguage=' + this.lang;
      }
      if (flag == 'imgView') {
        routerUrl = this.testBaseDomain + 'index?pop=photo&slanguage=' + this.lang;
      }
      if (flag == 'videoView') {
        routerUrl = this.testBaseDomain + 'index?pop=video&slanguage=' + this.lang;
      }
      window.open(routerUrl,'_self')
    },
    logins(val) {
      tools.login(val);
    },
    getQueryString(query) {
      const obj = this.$router.history.current.query;
      if (obj[query]) {
        return obj[query];
      } else {
        return '';
      }
    },
    // 跳转逻辑
    switchRouter() {
      const token = this.getQueryString('token');
      const viewToken = this.getQueryString('viewToken');
      const redirectUrl = this.getQueryString('redirectUrl');
      if (viewToken) {
        // 说明是从观众个人后台登录跳转过来的
        localStorage.setItem('viewToken', viewToken);
        this.hasViewToken = true;
      }
      if (token) {
        localStorage.setItem('token', token);
        this.hasToken = true;
      }
      if (redirectUrl) {
        window.location.href = decodeURIComponent(redirectUrl);
      }
    },
    isActive() {
      let key;
      const hrefRouter = window.location.href.split('#')[1].slice(1);
      if (hrefRouter.includes('?')) {
        const arr = hrefRouter.split('?');
        key = arr[0];
      } else {
        key = hrefRouter;
      }
      if (window.location.href.includes('exhibItem_detail')) {
        this.active.exhibitsList = true;
      }
      if (window.location.href.includes('exhibition_det')) {
        this.active.exhibition = true;
      }
      if (window.location.href.includes('active')) {
        this.active.active = true;
      }
      if (window.location.href.includes('live_detail')) {
        this.active.live = true;
      }
      if (window.location.href.includes('news_detail')) {
        this.active.exhibition = true;
      }
      this.active[key] = true;
    },
    // 切换语言包
    changeLang(e) {
      if (this.menu_disabled == true) {
        this.menu_disabled = false;
      }
      if (this.toggle == true) {
        // 当前显示的是中文图标,说明页面内容是英文,
        // todo: 把图标变为英文图标，内容变为中文
        this.toggle = false;
        localStorage.setItem('lang', 'zh');
        this.$i18n.locale = 'zh';
        this.lang = 'zh';
        // 存到localStorage的语言是zh
      } else if (this.toggle == false) {
        // 当前显示的是英文图标,说明页面内容是中文,
        // todo: 把图标变为中文图标，内容变为英文
        this.toggle = true;
        localStorage.setItem('lang', 'en');
        this.$i18n.locale = 'en';
        this.lang = 'en';
        // 存到localStorage的语言是en
      }
      window.location.reload();
    },
    // 切换菜单栏
    changeMenu() {
      this.menu_disabled = !this.menu_disabled;
      document.documentElement.scrollTop = 0;
      window.scrollTo(0, 0);
      if (this.menu_disabled == true) {
        // 去掉样式
        this.changeBodyStyle('false');
      } else {
        this.changeBodyStyle('true');
      }
    },
    toggleLink() {
      this.toggleable = !this.toggleable;
    },
    changeBodyStyle(flag) {
      const div = document.body;
      if (flag == 'false') {
        div.classList.add('bodyStyle');
      } else {
        div.classList.remove('bodyStyle');
      }
    },
  },
};
</script>
<style lang="scss">
.bodyStyle {
  height: 100%;
  overflow: hidden;
}
</style>
<style lang="scss" scoped>
.head {
  width: 100%;
  height: 13.3vw;
  opacity: 1;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 100;
  background: #006fb8;
  padding: 2.6vw 4vw;
  box-sizing: border-box;
  box-shadow: 0px 0px 7px 0px #006fb8 !important;
  .header {
    display: flex;
    .left {
      width: 50%;
      .title_log {
        display: flex;
        justify-content: column;
        align-items: center;
        img {
          height: 7.2vw;
        }
      }
    }
    .right {
      width: 50%;
      align-items: center;
      justify-content: flex-end;
      display: flex;
      .language {
        font-size: 3.7vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        display: flex;
        margin-left: 0.6vw;
        margin-right: 6.6vw;

        .chese {
          margin-left: 1.2vw;
          margin-right: 0.6vw;
          padding-right: 0.6vw;
          white-space: nowrap;
          cursor: pointer;
          img {
            vertical-align: middle;
            margin-right: 0.8vw;
          }
        }

        .english {
          margin-left: 1.2vw;
          margin-right: 0.6vw;
          padding-right: 0.6vw;
          white-space: nowrap;
          cursor: pointer;
          img {
            vertical-align: middle;
            margin-right: 0.8vw;
          }
        }
      }
      .menu {
        width: 4vw;
        .icon {
          width: 4.8vw;
          height: 3.2vw;
        }
        .close {
          width: 4.3vw;
          height: 4.3vw;
        }
      }
    }
  }
  .navMenus {
    position: absolute;
    top: 13.3vw;
    left: 0;
    width: 100%;
    background: #006fb8 !important;
    padding: 2.6vw;
    box-sizing: border-box;
    height: 100vh;
    overflow: hidden;
    overflow-y: scroll !important;
    z-index: 999;
    padding-bottom: 4vw;
    .menus {
      li {
        height: 15.2vw;
        // line-height: 15.2vw;
        border-bottom: 1px solid RGB(204, 204, 204, 0.5);
        text-decoration: none;
        list-style: none;
        color: #fff;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        a {
          color: #fff;
          text-decoration: none;
          font-size: 4.8vw;
        }
      }
      .online {
        border-bottom: 0px;
        .screenTitle {
          width: 100%;
          height: 6.6vw;
          background: #006fb8;
          padding: 0 1.87vw 0 0;
          line-height: 6.6vw;
          box-sizing: border-box;
          display: inline-block;
          .left {
            font-size: 4.8vw;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            float: left;
            width: 29.3vw;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .right {
            float: right;
            width: 3.2vw;
            height: 3.2vw;
            color: white;
          }
        }
      }

      .toggleLink {
        background: #10669f;
        border-bottom: 0px;
        padding-left: 6.6vw;
        box-sizing: border-box;
      }
      .login {
        margin-top: 8vw;
        margin-bottom: 8.6vw;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .btn {
          width: 48%;
          height: 9.6vw;
          line-height: 9.6vw;
          text-align: center;
          font-size: 4.2vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          border: 1px solid rgb(255, 255, 255, 0.5);
          border-radius: 8px;
        }
        .btn1 {
          width: 48%;
          height: 9.6vw;
          line-height: 9.6vw;
          text-align: center;
          font-size: 4.2vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #006fb8;
          border: 1px solid #ffffff;
          background: #fdd933;
          border-radius: 8px;
        }
      }
    }
  }
}
</style>
<style scoped>
.el-icon-menu,
.el-icon-close {
  font-size: 4vw;
  color: #fff;
}
</style>
